import { useEffect } from 'react'

export const useLockScroll = (active: boolean): void => {
    useEffect(() => {
        if (!active) return

        const root = document.documentElement
        const previous = root.style.overflow

        root.style.overflow = 'hidden'

        return () => {
            root.style.overflow = previous
        }
    }, [active])
}
